import { Button } from "@/components/atoms/buttons/Button";
import { Modal, ModalFoot, Sizes } from "@/components/molecules/modals/Modal";
import Image from "next/image";

interface Props {
  isOpen: boolean;
  handleClose: () => void;
}

export default function FlowExplanationModal({ isOpen, handleClose }: Props) {
  return (
    <Modal isOpen={isOpen} handleClose={handleClose} size={Sizes.XXXL}>
      <div className="text-center">
        <Image
          width={640}
          height={1092}
          src="/user/img/sales-to-payment-process-v2.png"
          alt="Explain the flow"
        />
      </div>

      <ModalFoot className="!justify-center px-6">
        <Button label="閉じる" color="bg-white" onClick={handleClose} />
      </ModalFoot>
    </Modal>
  );
}
